<template>
  <div>
    <b-card class="standardpage">
      <b-card-header v-if="selectedComponent == null">
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="allreports.icon" class="mr-1"></i>
            <span>{{ allreports.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>


      <!-- <b-row class="mt-2">
        <b-col>
          <b-button v-b-toggle.collapse-1 variant="secondary" style="border-radius:100%;"><i class="fa fa-chevron-down"
              aria-hidden="false"></i></b-button><span v-b-toggle.collapse-1> Favourites</span>
          <b-collapse id="collapse-1" class="mt-2">
            <b-card>
              <p class="card-text">Collapse contents Here</p>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row class="mt-2"><b-col>
          <b-button v-b-toggle.collapse-2 variant="secondary" style="border-radius:100%;"><i class="fa fa-chevron-down"
              aria-hidden="false"></i></b-button><span v-b-toggle.collapse-1> Client Reports</span>
          <b-collapse id="collapse-2" class="mt-2">
            <b-card>
              <p class="card-text">Collapse contents Here</p>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row> -->

      <!-- {{ allreports.items }} -->
      <div v-if="selectedComponent == null" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body>
            <div v-for="(category, cindex) in allreports.categories" :key="cindex" class="mb-3">
              <b-row>
                <b-col>
                  <b-card-header bg-variant="light" border-variant="light" class="listgroup_header bg-light py-1">
                    <div class="text-primary text-14px">
                      {{ category }}
                    </div>
                  </b-card-header>
                </b-col>
              </b-row>

              <div class="row">
                <div v-for="(report, index) in allreports.items.filter(r => r.category == category)" :key="index"
                  class="col-4 mb-1">
                  <b-list-group-item button :pressed="selectedComponent == 'Report'" @click="
                    runreport({
                      label: report.label,
                      id: report.component,
                    }, 'Report1')
                    ">
                    <b-row align-v="center" no-gutters>
                      <b-col cols="auto" class="mr-2"><i :class="report.icon"></i></b-col>
                      <b-col cols="10">
                        <span class="h5">{{ report.label }}</span>
                        <div>
                          <span>{{ report.description }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </div>
              </div>
            </div>

          </b-card-body>
        </b-card>
      </div>

      <div>
        <component :is="selectedComponent" :search="search" :showback="true" @discard="selectedComponent = null" />
      </div>

      <b-card-footer v-if="selectedComponent" class="mt-2 ml-1">
        <b-row>
          <b-col class="nopadding text-center">
            <b-button squared size="sm" variant="outline-primary" @click="selectedComponent = null">
              <i class="fa fa-bars mr-2"></i>All Reports
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

function dynamicSort(property) {
  var sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return function (a, b) {
    if (sortOrder == -1) {
      return b[property].localeCompare(a[property]);
    } else {
      return a[property].localeCompare(b[property]);
    }
  };
}


export default {
  name: "AllReports",
  data() {
    return {
      selectedComponent: null,
      allreports:
      {
        title: "Reports",
        icon: "fa fa-leanpub",
        debounce: 500,
        items: [],
        categories: []
      }
    };
  },
  async mounted() {
    await this.load()
  },
  methods: {
    async load() {

      let variables = {
        name: "allreports",
      };
      console.log("variables", variables);

      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_systemsettings($name: String) {
                setup_systemsettings(name: $name) {
                  data
                }
              }
            `,
          variables,
        });


        this.allreports.items = JSON.parse(response.data.setup_systemsettings[0].data);
        this.allreports.items.sort(dynamicSort('label'))

        this.allreports.categories = [...new Set(this.allreports.items.map(t => t.category))]
        this.allreports.categories = this.allreports.categories.sort()

      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    runreport(e, c) {
      console.log("run", e);
      if (c) {
        this.selectedComponent = c;
      } else {
        this.selectedComponent = "Report";
      }
      this.search = {
        name: e.label,
        call: e.id,
      };
    },
  }
}
</script>

<style></style>